import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../..';
import { fetchPartner } from '../partners.actions';
import { getPartnerBySlug } from '../partners.selectors';

export const usePartner = (slug: string) => {
  const [loading, setLoading] = useState(true);
  const partner = useSelector(getPartnerBySlug(slug));
  const dispatch = useAppDispatch();

  useEffect(() => {
    const loadPartner = async () => {
      setLoading(true);
      try {
        await dispatch(fetchPartner({ slug })).unwrap();
      } finally {
        setLoading(false);
      }
    };

    loadPartner();
  }, [dispatch, slug]);

  return {
    partner,
    loading,
  };
};
